import React from 'react';
import Card from '../Common/Card';
import { formatUSDT } from '../../utils/format';

const ROIChart = ({ stats, pendingROI }) => {
  return (
    <Card title="ROI Overview" subtitle="Real-time earnings breakdown">
      <div className="roi-chart">
        <div className="roi-row">
          <span className="roi-row-label">Active Capital</span>
          <span className="roi-row-value">{formatUSDT(stats.activeInvestment)} <span className="stat-suffix">USDT</span></span>
        </div>
        <div className="roi-row">
          <span className="roi-row-label">Pending ROI</span>
          <span className="roi-row-value text-green">{formatUSDT(pendingROI)} <span className="stat-suffix">USDT</span></span>
        </div>
        <div className="roi-row">
          <span className="roi-row-label">Lifetime Earnings</span>
          <span className="roi-row-value text-cyan">{formatUSDT(stats.totalEarned)} <span className="stat-suffix">USDT</span></span>
        </div>
        <div className="roi-row">
          <span className="roi-row-label">Claimable Now</span>
          <span className="roi-row-value text-purple">{formatUSDT(stats.pendingRewards)} <span className="stat-suffix">USDT</span></span>
        </div>
      </div>
    </Card>
  );
};

export default ROIChart;
